import { profileQueryKeys as e } from "./useProfileQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { profileApi as n } from "@maat/api-main";
//#region src/profile/useHostProfileQuery.ts
var r = (r = !0) => t({
	queryKey: e.hostProfile(),
	queryFn: n.getMyHostProfile,
	enabled: r
});
//#endregion
export { r as useHostProfileQuery };
